import React from 'react';
import { I18n } from '@td/shared_utils';
import { uniq } from 'lodash';

import { Medication } from '../../types/medication';

const MedicationForms = ({ drug }) => {
  return (
    <section>
      <h2>
        <I18n scope="medication_formularies.details.forms" text="title" />
      </h2>
      <table className="fields">
        <tbody>
          <tr>
            <th>
              <I18n scope="medication_formularies.details.forms.labels" text="route" />
            </th>
            <td>
              <ul>
                {uniq(drug.drugForms.map(drugForm => drugForm.productRouteDesc)).map(route => (
                  <li key={route}>{route}</li>
                ))}
              </ul>
            </td>
          </tr>
          <tr>
            <th>
              <I18n scope="medication_formularies.details.forms.labels" text="forms" />
            </th>
            <td>
              <ul>
                {uniq(drug.drugForms.map(drugForm => drugForm.form)).map(form => (
                  <li key={form}>{form}</li>
                ))}
              </ul>
            </td>
          </tr>
          <tr>
            <th>
              <I18n scope="medication_formularies.details.forms.labels" text="strength" />
            </th>
            <td>
              <ul>
                {uniq(drug.drugForms.map(drugForm => drugForm.productStrength)).map(strength => (
                  <li key={strength}>{strength}</li>
                ))}
              </ul>
            </td>
          </tr>
          <tr>
            <th>
              <I18n scope="medication_formularies.details.forms.labels" text="active_ingredients" />
            </th>
            <td>
              <ul>
                {uniq([
                  drug.genericDrug.activeIngredients,
                  ...drug.brandNameDrugs.map(brandNameDrug => brandNameDrug.activeIngredients)
                ]).map(activeIngredient => (
                  <li key={activeIngredient}>{activeIngredient}</li>
                ))}
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

MedicationForms.propTypes = {
  drug: Medication
};

export default MedicationForms;
